import { render } from "./DemoProduct.vue?vue&type=template&id=f2d8a50c&scoped=true"
import script from "./DemoProduct.vue?vue&type=script&lang=js"
export * from "./DemoProduct.vue?vue&type=script&lang=js"

import "./DemoProduct.vue?vue&type=style&index=0&id=f2d8a50c&lang=css&scoped=true"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d8a50c"]])

export default __exports__